import { type ReactElement } from 'react';
import { formatDuration } from '@/ui/formatters/formatDuration';
import { Text } from '@/ui/primitives';
import { tableV2DurationCellTextSx } from './TableV2MetadataCell.styles';

export const TableV2DurationCell = ({
  value,
}: {
  value: number | null | undefined;
}): ReactElement => (
  <Text role="body" color="textSecondary" sx={tableV2DurationCellTextSx}>
    {value === null || value === undefined ? '-' : formatDuration(value)}
  </Text>
);
